export const reasonOptions = [
  {
    color: '#D14539',
    text: 'Sleep',
    value: 'sleep'
  },
  {
    color: '#E99D52',
    text: 'Stress',
    value: 'stress_anxiety'
  },
  {
    color: '#E8D62F',
    text: 'Sadness',
    value: 'sadness'
  },
  {
    color: '#4F8ED6',
    text: 'Productivity',
    value: 'productivity'
  },
  {
    color: '#64BE79',
    text: 'Self Esteem',
    value: 'self_esteem'
  },
  {
    color: '#6EBEB5',
    text: 'Happiness',
    value: 'happiness_joy'
  },

  {
    color: '#6874C7',
    text: 'Manifesting',
    value: 'manifesting'
  },
  {
    color: '#8E63DB',
    text: 'Spirituality',
    value: 'spiritual_growth'
  },
  {
    color: '#603BA4',
    text: 'Meditation',
    value: 'i_just_want_to_meditate'
  },
  {
    text: 'For my Kids',
    value: 'meditation_for_my_kids'
  },
  {
    text: 'To connect with my Teacher',
    value: 'teacher'
  }
];

export const experienceOptions = [
  {
    text: 'Complete beginner',
    value: 'beginner'
  },
  {
    text: 'I’ve meditated a few times',
    value: 'intermediate'
  },
  {
    text: 'I meditate a lot',
    value: 'advanced'
  }
];

export const durationOptions = [
  {
    text: 'Less than 5 min',
    value: 'less_than_five_minutes'
  },
  {
    text: '5-10 min',
    value: 'five_to_ten_minutes'
  },
  {
    text: '10-15 min',
    value: 'ten_to_fifteen_minutes'
  },
  {
    text: '15-20 min',
    value: 'fifteen_to_twenty_minutes'
  },
  {
    text: '20-30 min',
    value: 'twenty_to_thirty_minutes'
  },
  {
    text: '30 min+',
    value: 'more_than_thirty_minutes'
  }
];

export const helpOptions = [
  {
    text: 'Sleep better',
    value: 'sleep'
  },
  {
    text: 'Reduce stress or anxiety',
    value: 'stress_anxiety'
  },
  {
    text: 'Meditation',
    value: 'i_just_want_to_meditate'
  },
  {
    text: 'Spirituality',
    value: 'spiritual_growth'
  },
  {
    text: 'Something else',
    value: 'other'
  }
];
